import { Component, Input } from '@angular/core';
import { EInvestmentFrequency } from 'src/models/common.model';
import { IPortfolioDepositOut } from 'src/models/products.model';

@Component({
  selector: 'liberro-regular-payment',
  standalone: false,
  templateUrl: './liberro-regular-payment.component.html',
  styleUrl: './liberro-regular-payment.component.less'
})
export class LiberroRegularPaymentComponent {
  @Input({ required: true }) public depositInfo!: IPortfolioDepositOut;
  @Input({ required: true }) public specificSymbol!: string;
  @Input({ required: true }) public depositFrequency!: EInvestmentFrequency | string;
  @Input() public showHeader? = false;
}
